import { useTonConnectUI, useTonWallet, useTonAddress } from "@tonconnect/ui-react";

export function useWalletDebug() {
    const [tonConnectUI] = useTonConnectUI();
    const wallet = useTonWallet();
    const address = useTonAddress();

    return { wallet, address };
}
